import React from 'react';
import { Instagram } from 'lucide-react';
import { clinicInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-sage-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Brand Section */}
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-gold-600" style={{ letterSpacing: '0.05em' }}>
            {clinicInfo.name}
          </h3>

          {/* Instagram */}
          <a
            href={clinicInfo.socialMedia.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="flex items-center gap-2 text-sage-300 hover:text-gold-600 transition-colors"
            aria-label="Instagram de Qara"
          >
            <Instagram className="w-5 h-5" />
            <span className="text-sm">@qara.mec</span>
          </a>

          {/* Copyright */}
          <p className="text-sage-300 text-sm">
            © {currentYear} {clinicInfo.name}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;